export const TOURNAMENT_START_BUFFER_MS = 60_000;
